<template>
  <div class="container">
    <!-- 人员培训 -->
    <div class="person-inspection-block" v-for="(item,index) in videoList" :key="index" @click="handleLocationHrefClick(item.type == 0 ? item.url:item.link)">
      <!-- 标题 -->
      <div class="person-inspection-block-title">
        {{!item.title? '暂无标题':item.title}}
        <div class="person-inspection-block-uptime">上传时间:{{item.createDate}}</div>
      </div>
      <!-- 右侧视频播放 -->
      <div class="person-inspection-block-img clearfix">
        <img :src="item.imgUrl" alt srcset />
        <img class="play-icon" src="@/images/play.png" alt srcset />
      </div>
    </div>
  </div>
</template>
<script>
import { PersonTraining } from "@/api/training";
export default {
  data() {
    return {
      videoList:''
    };
  },
  mounted() {
    this.requestPersonTraining()
  },
  methods: {
    // 请求视频列表
    requestPersonTraining() {
      PersonTraining().then(res => {
        console.log(res);
        this.videoList = res.data
      });
    },
    // 点击跳转
    handleLocationHrefClick(url) {
       window.location.href = url
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  // 视频图片列表
  .person-inspection-block {
    width: 349px;
    height: 110px;
    background-color: #ffffff;
    border-radius: 10px;
    margin: 10px auto;
    padding: 15px;
    box-sizing: border-box;
    .person-inspection-block-title {
      width: 169px;
      font-size: 17px;
      color: #333333;
      text-align: left;
      font-weight: bold;
      line-height: 1.5;
      float: left;
    }
    .person-inspection-block-uptime {
      font-size: 12px;
      color: #999999;
      text-align: left;
      margin-top: 10px;
    }
    .person-inspection-block-img {
      width: 120px;
      height: 80px;
      float: right;
      position: relative;
      img {
        width: 120px;
        height: 80px;
      }
      .play-icon {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 50%;
        margin-top: -12.5px;
        left: 50%;
        margin-left: -12.5px;
      }
    }
  }
}
</style>
